"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Optional = void 0;
class Optional {
    constructor(object) {
        this.object = object;
    }
    isPresent() {
        return this.object !== undefined && this.object !== null;
    }
    get() {
        return this.object;
    }
}
exports.Optional = Optional;
//# sourceMappingURL=optional.js.map